
// estilos del componente Loader
import '../style/Loader.css'

const Loader = () => {

    return (
        <div class="spinner"></div>
    )
}

export default Loader;